declare namespace $ {

	export class $mol_icon_comment extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=comment.view.tree.d.ts.map